import React from 'react'

import { MultipleChoiceCheckboxSkeleton } from '../../../../../concorde-renderers'
import { SuspendedControl } from '../../../SuspendedControl'

/**
 * Renders a Suspense-enabled version of MultichoiceCheckboxControl
 */
export const SuspendedMultichoiceCheckboxControl = SuspendedControl(
  React.lazy(() => import('../components/MultichoiceCheckbox')),
  MultipleChoiceCheckboxSkeleton
)
